"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _Menu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Menu"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var eventsUtils = _interopRequireWildcard(require("../../../utils/events"));
var filesUtils = _interopRequireWildcard(require("../../../utils/files"));
var _portals = require("../../../utils/portals");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var DownloadIcon = function DownloadIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 14a1 1 0 0 1 1 1v4h14v-4a1 1 0 1 1 2 0v4c0 1.103-.898 2-2 2H5c-1.102 0-2-.897-2-2v-4a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.707 16.705a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l1.295 1.295.008-9.559c0-.552.438-1 .99-.999.552 0 1.01.449 1.01 1.001l-.008 9.553 1.29-1.29a1 1 0 0 1 1.415 1.413l-3 3z"
  }));
};
DownloadIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var LinkIcon = function LinkIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.003 3.544a5.27 5.27 0 1 1 7.453 7.453l-3.45 3.45a5.271 5.271 0 0 1-6.885.495 1 1 0 1 1 1.2-1.6 3.271 3.271 0 0 0 4.27-.309l3.451-3.45a3.27 3.27 0 0 0-4.625-4.625l-.431.431a1 1 0 1 1-1.414-1.414l.431-.431zm-.324 7.115a3.271 3.271 0 0 0-4.27.307l-3.451 3.451a3.27 3.27 0 1 0 4.625 4.625l.431-.431a1 1 0 0 1 1.414 1.414l-.431.431a5.27 5.27 0 0 1-7.453-7.453l3.45-3.45a5.271 5.271 0 0 1 6.885-.494 1 1 0 1 1-1.2 1.6z"
  }));
};
LinkIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "action": "Download__action__1we9e",
  "label": "Download__label__3vhOq",
  "disabled": "Download__disabled__1LaaJ",
  "action-pira": "Download__action-pira__1JPZR",
  "actionPira": "Download__action-pira__1JPZR",
  "download-file-button": "Download__download-file-button__38Qg1",
  "downloadFileButton": "Download__download-file-button__38Qg1",
  "download": "Download__download__1k8DN",
  "popover-anchor": "Download__popover-anchor__3wUVR",
  "popoverAnchor": "Download__popover-anchor__3wUVR",
  "disabled-item": "Download__disabled-item__3b0jB",
  "disabledItem": "Download__disabled-item__3b0jB",
  "tooltip": "Download__tooltip__12Qo3"
}; 
require('./Download.css');
var buttonStyles = _Button.default.themes.DefaultTheme;
var Download = function Download(_ref) {
  var asset = _ref.asset,
    onDownload = _ref.onDownload,
    canEdit = _ref.canEdit;
  var portalConfiguration = _react.default.useContext(_exchangeReactHooks.AssetPortalContext);
  var store = (0, _reactRedux.useStore)();
  var state = store.getState();
  var isPortalReArchitectureEnabled = _exchangeUiPortalsStore.selectors.selectIsPIRAEnabled(state);
  var isStudio = (0, _exchangeReactHooks.useIsStudio)();
  var profile = (0, _exchangeReactHooks.useProfile)();
  var studioMetadata = (0, _exchangeReactHooks.useStudioMetadata)();
  var config = (0, _exchangeReactHooks.useConfig)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var popoverContainer = _react.default.useRef(null);
  var handleDownload = function handleDownload(event, file) {
    event.preventDefault();
    if (!file.url || isStudio) {
      onDownload(file);
    }
    filesUtils.download(file, isStudio, getPath);
  };
  var fileHasURL = function fileHasURL(file) {
    return !!file.url;
  };
  var getMenuItemContent = function getMenuItemContent(file) {
    var disabledTooltip = file.disabledTooltip && canEdit ? file.disabledTooltip : 'File is not available.';
    var menuItemText = file.dropdownLabel || "As ".concat(file.label);
    if (file.isDisabled) {
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        position: "left",
        content: /*#__PURE__*/_react.default.createElement("div", {
          className: styles.tooltip
        }, disabledTooltip)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(styles.label, styles.disabledItem)
      }, menuItemText));
    }
    return /*#__PURE__*/_react.default.createElement("a", {
      href: filesUtils.getFileURL(file, getPath),
      className: styles.popoverAnchor,
      target: "_blank",
      rel: "noopener noreferrer"
    }, menuItemText);
  };
  if (!(asset !== null && asset !== void 0 && asset.files)) {
    return null;
  }
  var _getTypeFiles = (0, _portals.getTypeFiles)(portalConfiguration === null || portalConfiguration === void 0 ? void 0 : portalConfiguration.files, asset, studioMetadata, 'private-portal-actions', config),
    _getTypeFiles$action = _getTypeFiles.action,
    action = _getTypeFiles$action === void 0 ? 'Download' : _getTypeFiles$action,
    files = _getTypeFiles.files;
  if (files.length === 0) {
    return null;
  }
  var isUserAuthenticated = !!profile;
  var actionStyle = isPortalReArchitectureEnabled ? (0, _classnames.default)(buttonStyles.button, buttonStyles.secondary, buttonStyles.md, buttonStyles.noFill, styles.actionPira, (0, _defineProperty2.default)({}, styles.disabled, !isUserAuthenticated || files[0].isDisabled)) : styles.action;
  if (!isUserAuthenticated || files.every(function (file) {
    return file.isDisabled;
  })) {
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      position: "bottom",
      content: files[0].disabledTooltip || 'Log into Anypoint Platform to download this asset'
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "data-test-id": "asset-action-download",
      className: (0, _classnames.default)(actionStyle),
      disabled: true
    }, !isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "s"
    }, fileHasURL(files[0]) ? /*#__PURE__*/_react.default.createElement(LinkIcon, null) : /*#__PURE__*/_react.default.createElement(DownloadIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.label
    }, action)));
  }
  if (files.length === 1) {
    return /*#__PURE__*/_react.default.createElement("a", {
      "data-test-id": "asset-action-download",
      className: actionStyle,
      href: filesUtils.getFileURL(files[0], getPath),
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: function onClick(event) {
        return handleDownload(event, files[0]);
      }
    }, !isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "s"
    }, fileHasURL(files[0]) && !isStudio ? /*#__PURE__*/_react.default.createElement(LinkIcon, null) : /*#__PURE__*/_react.default.createElement(DownloadIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.label
    }, action));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: popoverContainer
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    getPopoverContainer: function getPopoverContainer() {
      return popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.current;
    },
    testId: "asset-action-download-many",
    anchorPosition: "br",
    popupPosition: "tr",
    content: /*#__PURE__*/_react.default.createElement(_Menu.default, null, files.map(function (file) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        testId: "".concat(file.classifier, "-file"),
        key: file.classifier,
        disabled: file.isDisabled,
        onClick: function onClick(event) {
          return handleDownload(event, file);
        },
        onKeyDown: eventsUtils.onEnterKey(function (event) {
          return handleDownload(event, file);
        })
      }, getMenuItemContent(file));
    }))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(actionStyle, styles.download)
  }, !isPortalReArchitectureEnabled ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    isDecorative: true
  }, /*#__PURE__*/_react.default.createElement(DownloadIcon, null)) : null, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.label
  }, action), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: isPortalReArchitectureEnabled ? 20 : 's'
  }, /*#__PURE__*/_react.default.createElement(ArrowIcon, null)))));
};
Download.defaultProps = {
  canEdit: false
};
var _default = exports.default = Download;
//# sourceMappingURL=Download.js.map